import Vue from 'vue';
import storeLocal from 'storejs';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Tabs from '../views/Tabs.vue';

Vue.use(VueRouter);

// {
//   path: '/about',
//       name: 'about',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
//     meta: {requiresAuth: false},
// }

const routes = [
  {
    path: '/',
    name: 'free',

    component: () => import('../views/Free.vue'),
    meta: {
      title: '短网址二维码生成器',
      requiresAuth: false
    },
  },
  {
    path: '/free',
    name: 'free',

    component: () => import('../views/Free.vue'),
    meta: {
      title: '短网址二维码生成器',
      requiresAuth: false
    },
  },
  {
    path: '/home',
    name: 'home',

    component: Home,
    meta: {
      title: '短网址二维码生成器',
      requiresAuth: false
    },
  },



  {
    path: '/home_hm',
    name: 'home_hm',
    component: () => import('../views/Home_hm.vue'),
    meta: {
      title: '活码|短网址',
      requiresAuth: false
    },
  },
  {
    path: '/home_imgbig',
    name: '图片无损放大',
    component: () => import('../views/Home_imgbig.vue'),
    meta: {
      title: '图片放大器',
      requiresAuth: false
    },
  },
  {
    path: '/home_wx',
    name: 'home_wx',
    component: () => import('../views/Home_wx.vue'),
    meta: {
      title: '微信检测',
      requiresAuth: false},
  },
  {
    path: '/home_price',
    name: 'home_price',
    component: () => import('../views/Home_price.vue'),
    meta: {title: '收费标准|短网址',requiresAuth: false},
  },
  {
    path: '/home_shibie',
    name: 'home_shibie',
    component: () => import('../views/Home_shibie.vue'),
    meta: {requiresAuth: false},
  },
  {
    path: '/home_page',
    name: 'home_page',
    component: () => import('../views/Home_page.vue'),
    meta: {title: 'h5单页制作-短网址',requiresAuth: false},
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/other/Help.vue'),
    meta: {requiresAuth: false},
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/other/About.vue'),
    meta: {requiresAuth: false},
  },
  {
    path: '/guifan',
    name: 'guifan',
    meta: {
      title: '链接内容管理规范',
      requiresAuth: false,
    },
    component: () => import('../views/other/Guifan.vue'),
  },
  {
    path: '/yinsi',
    name: 'yinsi',
    meta: {
      title: '隐私政策',
      requiresAuth: false,
    },
    component: () => import('../views/other/Yinsi.vue'),
  },
  {
    path: '/xieyi',
    name: 'xieyi',
    meta: {
      title: '用户协议',
      requiresAuth: false,
    },
    component: () => import('../views/other/Xieyi.vue'),
  },
  {
    path: '/reg',
    name: 'reg',
    meta: {
      title: '用户注册',
      requiresAuth: false,
    },
    component: () => import('../views/site/Reg.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '用户登入',
      requiresAuth: false,
    },
    component: () => import('../views/site/Login.vue'),
  },
  {
    path: '/telegramAuth',
    name: 'telegramAuth',
    meta: {
      title: '天天短网址',
      requiresAuth: false,
    },
    component: () => import('../views/site/TelegramAuth.vue'),
  },
  {
    path: '/qrcode',
    name: 'qrcode',
    meta: {
      title: '二维码',
      requiresAuth: false,
    },
    component: () => import('../views/site/Qrcode.vue'),
  },
  {
    path: '/apidoc',
    name: 'apidoc',
    meta: {
      title: 'api文档',
      requiresAuth: false,
    },
    component: () => import('../views/other/ApiDoc.vue'),
  },
  {
    path: '/statisticsDemo',
    name: 'statisticsDemo',
    meta: {
      title: '数据统计DEMO',
      requiresAuth: false,
    },
    component: () => import('../views/other/StatisticsDemo.vue'),
  },
  {
    path: '/exlcusiveDomain',
    name: 'exlcusiveDomain',
    meta: {
      title: '专属域名介绍',
      requiresAuth: false,
    },
    component: () => import('../views/other/ExlcusiveDomain.vue'),
  },
  {
    path: '/statistics/:id',
    name: 'statistics',
    meta: {
      title: '数据统计',
      requiresAuth: true,
    },
    component: () => import('../views/short/Statistics.vue'),
  },

  {
    path: '/conversion/:id',
    name: 'conversion',
    meta: {
      title: '转换结果',
      requiresAuth: false,
    },
    component: () => import('../views/other/Conversion.vue'),
  },
  {
    path: '/freeResult/:id',
    name: 'freeResult',
    meta: {
      title: '转换结果',
      requiresAuth: false,
    },
    component: () => import('../views/other/FreeResult.vue'),
  },
  {
    path: '/recording',
    name: 'recording',
    meta: {
      title: '转换记录',
      requiresAuth: false,
    },
    component: () => import('../views/other/Recording.vue'),
  },
  {
    path: '/tabs',
    name: 'tabs',
    meta: {requiresAuth: true},
    component: Tabs,
    children: [
      {
        path: 'index',
        name: 'index',
        meta: {
          title: '短网址转换',
          requiresAuth: true,
        },
        component: () => import('../views/short/Index.vue'),
      },
      {
        path: '/tabs/stat',
        name: 'stat',
        meta: {
          title: '数据统计',
          requiresAuth: true,
        },
        component: () => import('../views/short/Stat.vue'),
      },
      {
        path: 'renling',
        name: 'renling',
        meta: {
          title: '认领短网址',
          requiresAuth: true,
        },
        component: () => import('../views/short/Renling.vue'),
      },
      {
        path: 'tool',
        name: 'tool',
        meta: {
          title: '工具大全',
          requiresAuth: true,
        },
        component: () => import('../views/tools/Tool.vue'),
      },
      {
        path: 'charge',
        name: 'charge',
        meta: {
          title: '用户充值',
          requiresAuth: true,
        },
        component: () => import('../views/user/Charge.vue'),
      },

      {
        path: 'batchConversion',
        name: 'batchConversion',
        meta: {
          title: '短网址批量转换',
          requiresAuth: true,
        },
        component: () => import('../views/short/BatchConversion.vue'),
      },
      {
        path: 'webPage',
        name: 'webPage',
        meta: {
          title: 'h5页面创作',
          requiresAuth: true,
        },
        component: () => import('../views/webPage/WebPage.vue'),
      },
      {
        path: 'webPageList',
        name: 'webPageList',
        meta: {
          title: '我的h5页面',
          requiresAuth: true,
        },
        component: () => import('../views/webPage/WebPageList.vue'),
      },
      {
        path: 'setWebPage/:id',
        name: 'setWebPage',
        meta: {
          title: '修改H5页面',
          requiresAuth: true,
        },
        component: () => import('../views/webPage/SetWebPage.vue'),
      },
      {
        path: 'imgbig',
        name: 'imgbig_index',
        meta: {
          title: '我的图片放大',
          requiresAuth: true,
        },
        component: () => import('../views/imgbig/index.vue'),
      },
      {
        path: 'shopGoods',
        name: 'shopGoods',
        meta: {
          title: '淘宝短链接',
          requiresAuth: true,
        },
        component: () => import('../views/exclusive/ShopGoods.vue'),
      },
      {
        path: 'exclusiveShort',
        name: 'exclusiveShort',
        meta: {
          title: '专属域名转换',
          requiresAuth: true,
        },
        component: () => import('../views/exclusive/ShortUrl.vue'),
      },
      {
        path: 'shortUrlList',
        name: 'shortUrlList',
        meta: {
          title: '用户链接列表',
          requiresAuth: true,
        },
        component: () => import('../views/short/ShortUrlList.vue'),
      },      {
        path: 'liveCodeList',
        name: 'liveCodeList',
        meta: {
          title: '我的粉活码',
          requiresAuth: true,
        },
        component: () => import('../views/short/LiveCodeList.vue'),
      },
      {
        path: 'weiboIndex',
        name: 'weiboIndex',
        meta: {
          title: '微博链接转换',
          requiresAuth: true,
        },
        component: () => import('../views/weibo/Index.vue'),
      },
      {
        path: 'manage/:id',
        name: 'manage',
        meta: {
          title: '链接管理',
          requiresAuth: true,
        },
        component: () => import('../views/short/Manage.vue'),
      },
      {
        path: 'advanced/:id',
        name: 'advanced',
        meta: {
          title: '高级功能',
          requiresAuth: true,
        },
        component: () => import('../views/short/Advanced.vue'),
      },
      {
        path: 'channel/:id',
        name: 'channel',
        meta: {
          title: '链接渠道管理',
          requiresAuth: true,
        },
        component: () => import('../views/short/Channel.vue'),
      },
      {
        path: 'userLabel',
        name: 'userLabel',
        meta: {
          title: '分类管理',
          requiresAuth: true,
        },
        component: () => import('../views/short/UserLabel.vue'),
      },
      {
        path: 'liveCode',
        name: 'liveCode',
        meta: {
          title: '加群加粉活码',
          requiresAuth: true,
        },
        component: () => import('../views/short/LiveCode.vue'),
      },
      {
        path: 'xcx/index',
        name: 'xcx',
        meta: {
          title: '小程序管理',
          requiresAuth: true,
        },
        component: () => import('../views/xcx/index.vue'),
      },
      {
        path: 'xcx/link',
        name: 'xcx',
        meta: {
          title: '小程序链接管理',
          requiresAuth: true,
        },
        component: () => import('../views/xcx/link.vue'),
      },
      {
        path: 'payCode',
        name: 'payCode',
        meta: {
          title: '付款码合并',
          requiresAuth: true,
        },
        component: () => import('../views/short/PayCode.vue'),
      },
      {
        path: 'payCodeList',
        name: 'payCodeList',
        meta: {
          title: '我的付款码',
          requiresAuth: true,
        },
        component: () => import('../views/short/PayCodeList.vue'),
      },
      {
        path: 'MyliveCode/:id',
        name: 'MyliveCode',
        meta: {
          title: '活码设置',
          requiresAuth: true,
        },
        component: () => import('../views/short/MyLiveCode.vue'),
      },
      {
        path: 'MyPayCode/:id',
        name: 'MyPayCode',
        meta: {
          title: '收款码设置',
          requiresAuth: true,
        },
        component: () => import('../views/short/MyPayCode.vue'),
      },
      {
        path: 'GroupingliveCode',
        name: 'GroupingliveCode',
        meta: {
          title: '群组活码设置',
          requiresAuth: true,
        },
        component: () => import('../views/short/GroupingLiveCode.vue'),
      },
      {
        path: 'buyDomain',
        name: 'buyDomain',
        meta: {
          title: '专属域名购买',
          requiresAuth: true,
        },
        component: () => import('../views/exclusive/BuyDomain.vue'),
      },
      {
        path: 'domainOrder',
        name: 'domainOrder',
        meta: {
          title: '专属域名订单列表',
          requiresAuth: true,
        },
        component: () => import('../views/exclusive/DomainOrder.vue'),
      },
      {
        path: 'exclusiveDomain',
        name: 'exclusiveDomain',
        meta: {
          title: '我的专属域名',
          requiresAuth: true,
        },
        component: () => import('../views/exclusive/Domain.vue'),
      },
      {
        path: 'exclusiveDomain2',
        name: 'exclusiveDomain2',
        meta: {
          title: '专属域名监控',
          requiresAuth: true,
        },
        component: () => import('../views/exclusive/Domain2.vue'),
      },
      {
        path: 'ckUrlList',
        name: 'ckUrlList',
        meta: {
          title: '网站监控列表',
          requiresAuth: true,
        },
        component: () => import('../views/monitorUrl/UserCkUrl.vue'),
      },
      {
        path: 'longurl',
        name: 'longurl',
        meta: {
          title: '专属中间域名',
          requiresAuth: true,
        },
        component: () => import('../views/exclusive/UserLongurl.vue'),
      },
      {
        path: 'vipContrast',
        name: 'vipContrast',
        meta: {
          title: 'VIP套餐对比',
          requiresAuth: true,
        },
        component: () => import('../views/vip/Contrast.vue'),
      },
      {
        path: 'vipRecharge',
        name: 'vipRecharge',
        meta: {
          title: 'VIP开通',
          requiresAuth: true,
        },
        component: () => import('../views/vip/Recharge.vue'),
      },
      {
        path: 'flowRecharge',
        name: 'flowRecharge',
        meta: {
          title: '购买访问包',
          requiresAuth: true,
        },
        component: () => import('../views/flowPack/FlowRecharge.vue'),
      },
      {
        path: 'h5Recharge',
        name: 'h5Recharge',
        meta: {
          title: '购买单页包',
          requiresAuth: true,
        },
        component: () => import('../views/webPage/H5Recharge.vue'),
      },
      {
        path: 'flowList',
        name: 'flowList',
        meta: {
          title: '我的访问包',
          requiresAuth: true,
        },
        component: () => import('../views/flowPack/FlowPackList.vue'),
      },
      {
        path: 'userInfo',
        name: 'userInfo',
        meta: {
          title: '用户信息',
          requiresAuth: true,
        },
        component: () => import('../views/user/Info.vue'),
      },
      {
        path: 'certification',
        name: 'certification',
        meta: {
          title: '实名认证',
          requiresAuth: true,
        },
        component: () => import('../views/user/Certification.vue'),
      },


      {
        path: 'editPass',
        name: 'editPass',
        meta: {
          title: '密码重置',
          requiresAuth: true,
        },
        component: () => import('../views/user/EditPass.vue'),
      },
      {
        path: 'userToken',
        name: 'userToken',
        meta: {
          title: 'API Token',
          requiresAuth: true,
        },
        component: () => import('../views/user/Token.vue'),
      },
      {
        path: 'message',
        name: 'message',
        meta: {
          title: '消息中心',
          requiresAuth: true,
        },
        component: () => import('../views/user/Message.vue'),
      }
    ]
  },
  {
    path: '*',
    name: 'all',
    component: Home,
    meta: {requiresAuth: false},
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  // console.log('to',to);
  // console.log('from',from);
  // console.log('router.beforeEach');

  const token = storeLocal.get('token');
  const title = to.meta.title;
  const requiresAuth = to.meta.requiresAuth;

  if(title) {
    document.title = title;
  }else {
    document.title = '天天短网址';
  }

  if (requiresAuth) {
    if (token === null || token === '' || token === undefined){
      next('/login');
    }else {
      next();
    }
  } else {
    next();
  }
});

export default router
